// extracted by mini-css-extract-plugin
export default {"calendar":"Calendar_calendar__YR23G","dark":"Calendar_dark__of1Wd","textHeading":"Calendar_textHeading__zqvi-"};